import { Skeleton } from "@/components/ui/skeleton";

const ARCHIVED_SKELETON_KEYS = [
  "archived-skeleton-1",
  "archived-skeleton-2",
  "archived-skeleton-3",
];

export const ArchivedChatsSkeleton = (): React.ReactElement => (
  <div className="space-y-2 px-2" data-testid="archived-chats-loading-state">
    {ARCHIVED_SKELETON_KEYS.map((key) => (
      <Skeleton key={key} className="h-10 w-full rounded-md" />
    ))}
  </div>
);
